<template>
  <div>
    <p v-if="emotes.length == 0">Loading data from server...</p>
    <div v-else>
      <div class="filterbar">

        <div class="rarity-check">
        <multiselect v-model="checkedRarities" :options="rarities" :multiple="true" :close-on-select="false" :clear-on-select="false" :searchable="false"
        placeholder="Choose Rarities" :preselect-first="true" deselectLabel="Exclude" selectLabel="Include" selectedLabel="" :customLabel="rarityLabel" :allowEmpty="false">
          <template slot="selection" slot-scope="{ values, isOpen }">
            <span class="multiselect__single" v-if="checkedRarities.length &amp;&amp; !isOpen">
              {{ checkedRarities.length == 4 ? "All" : checkedRarities.length }} {{checkedRarities.length == 1 ? "Rarity" : "Rarities"}}</span>
          </template>
        </multiselect>
        </div>

        <input type="text" placeholder="Search" v-model="filterStr">
        <i class="fas fa-eraser clearer" v-on:click="clearFilter()"></i>
      </div>
      <YoutubeModal v-if="showModal" @close="showModal = false" ref="modal"/>

      <div v-if="filterStr.length === 0 && leaks.length > 0" class="featured-content">
        <!-- Leaks -->
        <div class="grid-title">Current Leaks</div>
        <row class="row">
          <column v-for="leak of leaks" v-bind:key="leak.id" xs="5" sm="4" md="3" :lg="getLG(leaks.length)" class="col-j" >
            <div :class="'card-'+leak.rarity+' card-base'" @click="showVideo(leak.videoId)">
              <img :src="getImgUrl(leak.id)" :alt="leak.name">
              <div class="card-title">
                <h3 class="card-title-text">
                  <span>{{ leak.name }}</span>
                </h3>
              </div>
            </div>
          </column>
        </row>
      </div>

      <div v-if="filterStr.length === 0 && latest.length > 0" class="featured-content">
        <!-- Latest -->
        <div class="grid-title">6 Newest Emotes</div>
        <row class="row">
          <column v-for="emote of latest" v-bind:key="emote.id" xs="5" sm="4" md="3" lg="2">
            <div :class="'card-'+emote.rarity+' card-base'" @click="showVideo(emote.defaultVideo)">
            <div v-if="emote.defaultVideo !== null">
              <router-link class="card-vidcount" :to="'/emote/'+emote.slug">
                <i class="fa fa-info info-c"></i>
              </router-link>
            </div>
            <div v-else-if="emote.defaultVideo === 0" class="card-novidcount">
              <i class="fab fa-youtube"></i>
              <div class="vidcount-text">0</div>
            </div>
            <img
              v-lazyload
              data-err="@/assets/img/missing.png"
              :data-src="'https://image.fnbr.co/emote/'+emote.id + '/icon.png'"
              src="@/assets/img/loading.png"
              :alt="emote.name"
            >
            <div class="card-title">
              <h3 class="card-title-text">
                <span>{{ emote.name }}</span>
              </h3>
            </div>
          </div>
          </column>
        </row>
      </div>

      <!-- Main Content -->
      <div class="grid-title">All Emotes</div>
      <row class="row">
        <p v-if="filterEmotes(filterStr) == false">There were no emotes matching your text/rarity filter, try something else.</p>
        <column v-for="emote of filterEmotes()" v-bind:key="emote.id" xs="5" sm="4" md="3" lg="2">
          <div :class="'card-'+emote.rarity+' card-base'" @click="showVideo(emote.defaultVideo)">
            <div v-if="emote.defaultVideo !== null">
              <router-link class="card-vidcount" :to="'/emote/'+emote.slug">
                <i class="fa fa-info info-c"></i>
              </router-link>
            </div>
            <div v-else-if="emote.defaultVideo === null" class="card-novidcount">
              <i class="fab fa-youtube"></i>
              <div class="vidcount-text">0</div>
            </div>

            <img
              v-lazyload
              data-err="@/assets/img/missing.png"
              :data-src="'https://image.fnbr.co/emote/'+emote.id + '/icon.png'"
              src="@/assets/img/loading.png"
              :alt="emote.name"
            >
            <div class="card-title">
              <h3 class="card-title-text">
                <span>{{ emote.name }}</span>
              </h3>
            </div>
          </div>
        </column>
      </row>
    </div>
  </div>
</template>


<script>
/* eslint-disable */
import FilterMenu from "./FilterMenu.vue";
import YoutubeModal from "./YoutubeModal.vue";

export default {
  name: "EmotesMain",

  components: {
    FilterMenu,
    YoutubeModal
  },

  data() {
    return {
      filterStr: "",
      showModal: false,
      videoId: "t",
      checkedRarities: [
        "epic",
        "rare",
        "uncommon",
        "common",
        "star_wars",
        "marvel",
        "icon_series",
        "frozen",
        "dc",
        "gaming_legends"
      ],
      rarities: [
        "epic",
        "rare",
        "uncommon",
        "common",
        "star_wars",
        "marvel",
        "icon_series",
        "frozen",
        "dc",
        "gaming_legends"
      ]
    };
  },

  created() {
    this.$store.dispatch("loadEmotes");
    this.$store.dispatch("loadLeaks");
    this.$store.dispatch("loadLatest");
    //this.$store.dispatch("loadSiteStats");
  },

  computed: {
    emotes() {
      console.log("Emotes@Main");
      return this.$store.state.emotes;
    },
    leaks() {
      console.log("Leaks@Main");
      return this.$store.state.leaks;
    },
    latest() {
      console.log("Latest@Main");
      return this.$store.state.latest;
    }
  },

  methods: {
    rarityLabel: function(label) {
      if(label === "dc") return "DC";
      if(label === "star_wars") return "Star Wars";
      if(label === "icon_series") return "Icon Series";
      if(label === "gaming_legends") return "Gaming Legends";
      return label.substring(0,1).toUpperCase()+label.substring(1).replace("_"," ");
    },
    getImgUrl: function(id) {
      return "https://image.fnbr.co/emote/" + id + "/icon.png";
    },
    clearFilter: function() {
      this.filterStr = "";
    },
    filterEmotes: function() {
      var nameFiltered = this.emotes.filter(e =>
        e.name.toLowerCase().includes(this.filterStr.toLowerCase()));
      var rarityFiltered = nameFiltered.filter(e => this.checkedRarities.includes(e.rarity));
      return rarityFiltered;
    },
    showVideo: function(videoId) {
      if (videoId === null) return;

      console.log("VideoID: " + videoId);
      this.$store.commit("setModalVideo", videoId);
      this.showModal = true;
    },
    getLG: function(elementCount) {
      if(elementCount > 5){
        return "2";
      }
      switch (elementCount) {
        case 1:
          return "6";
        case 2:
          return "6";
        case 3:
          return "4";
        case 5:
          return "2";
        case 6:
          return "2";
        case 7:
          return "2";
        case 8:
          return "2";
        default:
          return "3";
      }
    }
  }
};
</script>

<style scoped>
@import "https://use.fontawesome.com/releases/v5.5.0/css/all.css";

.clearer{
  padding-left:5px;
}

.rarity-check{
  display:inline-block;
  height: 40px;
  width: 150px;
  padding-right: 5px;
}

.col-j {
  margin-left: auto;
  margin-right: auto;
}

p {
  color: white;
  font-size: 150%;
}

i {
  color: white;
  font-size: 150%;
  cursor: pointer;
}
input {
  width: calc(100% - 100px);
  max-width: 120px;
  border: 0;
  padding: 10px;
  font-size: 1.3em;
  background-color: #323333;
  color: #687f7f;
}

@media (min-width: 576px){ 
  input {
    max-width: 250px;
  }
 }


@media (min-width: 768px) { 
  input {
    max-width: 250px;
  }
 }


@media (min-width: 992px) { 
  input {
    max-width: 250px;
  }
 }

.grid-title {
  font-family: "Luckiest Guy", Lato, Roboto, Calibri, Arial;
  color: white;
  font-size: 150%;
  padding-top: 10px;
}

.filterbar {
  width: 100%;
  height: 49px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.row {
  justify-content: center; /* align horizontal */
}

img {
  vertical-align: middle;
  max-width: 100%;
  height: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/EmotesMain.vue